module.exports = __webpack_public_path__ + "media/bootstrap-icons/sd-card-f0f96b34.svg";